export const childcarePlans = [
  {
    id: 1,
    name: "Plan África",
    price: 170000,
    features: [
      "Revisión minuciosa de CVs con experiencia y referencias",
      "Presentación de la propuesta laboral a las candidatas",
      "Entrevistas y preselección según el perfil solicitado",
      "Entrevistas presenciales a cargo de la familia",
      "Garantía de 10 días"
    ],
    recommended: false,
    badge: "Básico"
  },
  {
    id: 2,
    name: "Plan Mundial",
    price: 190000,
    features: [
      "Revisión detallada de CVs con verificación de referencias",
      "Contacto directo con postulantes",
      "Entrevista personalizada",
      "Preselección de 3-4 perfiles destacados",
      "Certificado de antecedentes penales incluido",
      "Garantía de 1 mes"
    ],
    recommended: false,
    badge: "Popular"
  },
  {
    id: 3,
    name: "Plan Mundial XL",
    price: 240000,
    features: [
      "Todos los beneficios del Plan Mundial",
      "Certificado médico emitido por nuestra doctora",
      "Garantía extendida a 45 días"
    ],
    recommended: true,
    badge: "Mejor valorado"
  },
  {
    id: 4,
    name: "Plan Terraqueal",
    price: 430000,
    features: [
      "Todos los beneficios del Plan Mundial XL",
      "Reclutamiento, entrevistas y preselección de candidatas",
      "Entrega de 3 certificados (médico, psicológico, antecedentes penales)",
      "Equipo propio de doctora y psicólogas",
      "Llamado a referencias de las niñeras seleccionadas",
      "Garantía extendida de 3 meses"
    ],
    recommended: false,
    badge: "Premium"
  }
];